import { AppData, Lightning, Log, Utils } from "@lightningjs/sdk";
import { Base, Icon, Shadow } from "@lightningjs/ui-components"
import { AppSetup } from "../lib/app-setup";
import { Helper } from "../lib/helper";

export default class ControlIcon extends Base<Base.TemplateSpec> {
    [x: string]: any;
    currStateIndex = 0
    currIcon = ''
    static get __componentName() {
        return 'ControlIcon'
    }

    static override _template(): Lightning.Component.Template<Lightning.Component.TemplateSpecLoose> {
        return {
            w: (w) => w,
            h: (h) => h,
            Icon: {
                x: (w) => w/2,
                y: (h) => h/2,
                mount:0.5
            },
        }
    }

    static get properties() {
        return ['action', 'icons', 'stateIndex', 'sprite', 'tts'];
    }


    static get tags() {
        return ['Icon']
    }

    _update() {
        const {appState} = AppData as AppSetup
        const appApiConfig = appState?.getAppApiConfig() 
        this._updateState()
        this.alpha = this.skipFocus ? 0.5 : 1
        const pos = this._sprite[this._stateIndex]
        this.visible = true;
        if(this.skipFocus){
            this.visible = false;
        }
        //const color = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)
        pos.y = this.hasFocus() ? 144 : 0
        const patchObj = {
            //texture: Lightning.Tools.getSvgTexture(Utils.asset(`/svg/${this.currIcon}${this.hasFocus() ? '-on':''}.svg`), this.finalW, this.finalH)
            //mount:0.5,
            x: this.finalW/2,
            w: this.w,h: this.h,
            //colorUl: color, colorUr: color, colorBl: color, colorBr: color,
            texture: {
                resizeMode: {type: 'cover', w: 144, h: 144},
                ...pos,w:144,h:144,
                type: Lightning.textures.ImageTexture, src: Utils.asset(`/images/player_control_sprite_updated.png`)
            }
        }
        // if(this.hasFocus()) {
        //     //patchObj.color = color
        //     patchObj.colorUl = color
        //     patchObj.colorUr = color
        //     patchObj.colorBl = color
        //     patchObj.colorBr = color
        // }
        this._Icon.patch(patchObj)
    }

    _updateState() {
        if(!this._stateIndex || this._stateIndex > this._icons.length-1) {
            this._stateIndex = 0
        }
        this.currIcon = this._icons[this._stateIndex]
    }

    override _handleEnter() {
        this.fireAncestors('$ItemSelected', this._action)
    }

    override _focus() {
        this._update()
        const {platform} = AppData as AppSetup
        platform?.textToSpeach(this._tts)
        this.setSmooth('scale', 1.1)
        this.fireAncestors('$ItemChanged')
        
    }

    override _unfocus() {
        this._update()
        this.setSmooth('scale', 1)
    }

    _handleHover(target) {
        // console.log('Control-icon', target)
        this._focus()
    }

    _handleUnhover(target) {
        // console.log('Control-icon', target)
        this._unfocus()
    }
}
